<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Cronograma Físico -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label class="required">Ação</label>
                    <b-input-group>
                        <b-form-select
                            v-model="acaoId"
                            type="text"
                            :options="acoes"
                            value-field="acaoId"
                            text-field="nomeAcao"
                        ></b-form-select>
                        <b-form-invalid-feedback>A Ação é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group>
                    <label class="required">Ano</label>
                    <b-input-group>
                        <date-picker
                            v-model="ano"
                            :config="$yearPickerOptions"
                            v-mask="'####'"
                        ></date-picker>
                        <b-form-invalid-feedback>O ano é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label class="required">Meses</label>
                    <b-input-group>
                        <b-button-group>
                            <b-button
                                v-model="mesesSelecionados"
                                v-for="(mes, index) in mesesDisponiveis"
                                :key="index"
                                v-bind:variant="mesesSelecionados.includes(mes.value) ? 'primary' : 'outline-secondary'"
                                @click="toggleMonth(mes.value)">
                                {{ mes.text }}
                            </b-button>
                        </b-button-group>
                        <b-form-invalid-feedback>Pelo menos um mês deve ser selecionado</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        pleito: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },
    validations: {
        acaoId: {
            required
        },
        mesesSelecionados: {
            mesesOk(){
                return this.mesesSelecionados.length > 0
            }
        },
        ano: {
            required
        },
    },
    data() {
        return {
            ano: null,
            acaoId:null,
            acoes: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            mesesSelecionados: [],
            mesesDisponiveis: [
                { value: 1, text: 'Janeiro' },
                { value: 2, text: 'Fevereiro' },
                { value: 3, text: 'Março' },
                { value: 4, text: 'Abril' },
                { value: 5, text: 'Maio' },
                { value: 6, text: 'Junho' },
                { value: 7, text: 'Julho' },
                { value: 8, text: 'Agosto' },
                { value: 9, text: 'Setembro' },
                { value: 10, text: 'Outubro' },
                { value: 11, text: 'Novembro' },
                { value: 12, text: 'Dezembro' }
            ]
        }
    },
    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },
    methods: {
        preencher() {
            this.obterAcoes(this.pleito.pleitoId)
            if (this.operacaoProp == 'A') {
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.acaoId = null
            this.mesesSelecionados = []
            this.ano = null
        },

        obterAcoes(pleitoId){
            this.$store.dispatch('addRequest')
            this.dataServicos.obterAcoes(pleitoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    }
                )
        },

        salvar() {
            let cronogramaFisicoDto = {
                pleitoId : this.pleito.pleitoId,
                acaoId: this.acaoId,
                meses: this.mesesSelecionados,
                ano: this.ano
            }
            this.$emit('salvar', cronogramaFisicoDto)
            this.fecharModal()
        },

        toggleMonth(month) {
            if (this.mesesSelecionados.includes(month)) {
                this.mesesSelecionados = this.mesesSelecionados.filter(m => m !== month)
            } else {
                this.mesesSelecionados.push(month)
            }
        }
    },
}
</script>
